<lazy-echart class="chart" [class.chart--fixed-height]="hasFixedHeight"
    [options]="cdfChartOptions">
</lazy-echart>
